import { PIC, doSubmit, PICPicker, PICMenu, fetchFormData, PICLoadPage, PICSelector, PICSuggestion, PICModal, PICDualDate, PICTime, PICDate, PICHatchClerk, PICTab, PICWebTable, Util } from '../templates/Internals';
export class GlobEvents {
    constructor() {
        //TODO: implement pickers
        this.uploadfields = [];
        this.pickers = [];
        this.menus = [];
        this.listeners = new Map();
        this.lazyTables = [];
        this.openModals = [];
    }
    set activePicker(picker_) {
        var _a;
        let pickerObj;
        let pickerMode;
        let iPicker;
        if (picker_) {
            if (picker_ instanceof PICPicker || picker_ instanceof PICMenu) {
                pickerMode = undefined;
                iPicker = picker_;
                pickerObj = { pickerMode: pickerMode, picker: iPicker };
            }
            else {
                pickerMode = picker_.pickerMode;
                iPicker = picker_.picker;
                pickerObj = picker_;
            }
        }
        else {
            pickerMode = undefined;
            iPicker = undefined;
            pickerObj = undefined;
        }
        //if(!picker_ && !pickerMode && !iPicker && !pickerObj) return;
        if (this.activePicker_) {
            if (this.activePicker_ == pickerObj) {
            }
            else if (!iPicker) {
                this.activePicker_ = pickerObj;
            }
            else if (this.activePicker_ !== pickerObj) {
                (_a = this.activePicker_.picker) === null || _a === void 0 ? void 0 : _a.hide();
                this.activePicker_ = pickerObj;
            }
        }
        else {
            this.activePicker_ = pickerObj;
        }
    }
    get activePicker() {
        return this.activePicker_;
    }
    get topModal() {
        return this.topModal_;
    }
    set topModal(modal) {
        this.topModal_ = modal;
    }
    setActiveModalFocusElements(iLoadPageElement, iFirstElement, iLastElement) {
        this.activeModal = iLoadPageElement;
        this.activeModalLastElm = iLastElement;
        this.activeModalFirstElm = iFirstElement;
    }
    clearActiveModalFocusElements() {
        this.activeModal = null;
        this.activeModalLastElm = null;
        this.activeModalFirstElm = null;
    }
    addEventListener(eventType, eventFunction, iOption) {
        this.listeners.set(eventType + ',' + eventFunction.name + guid(), {
            eventType: eventType,
            eventFunction: eventFunction,
        });
        window.tmpPrevent = false;
        window.addEventListener(eventType, eventFunction, iOption);
        function guid() {
            function _p8(s) {
                var p = (Math.random().toString(16) + "000000000").substr(2, 8);
                return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
            }
            return _p8() + _p8(true) + _p8(true) + _p8();
        }
    }
    removeEventListener(eventType, eventFunction) {
        //@ts-ignore
        window.removeEventListener(eventType, eventFunction);
        this.listeners.delete(eventType + ',' + eventFunction.name);
    }
    addEventOnce(eventType, eventFunction, iOption) {
        let ref = this;
        let wrappedFunc = function (e) {
            eventFunction(e);
            window.removeEventListener(eventType, wrappedFunc, iOption);
            ref.listeners.delete(eventType + ',' + eventFunction.name);
        };
        this.listeners.set(eventType + ',' + eventFunction.name, {
            eventType: eventType,
            eventFunction: eventFunction,
        });
        window.addEventListener(eventType, wrappedFunc, iOption);
    }
    clearEventListeners() {
        this.listeners.forEach(function (listener) {
            if (listener.eventType != 'error')
                window.removeEventListener(listener.eventType, listener.eventFunction);
        });
    }
    //TODO: WEB2PRO cleanup subevents the same way bit with picwinmap
    clearSubEvents( /*PICSubWin: { [index: string]: any }*/) {
        // Object.entries(PICSubWin).forEach(curEntry => {
        //     if (curEntry.length > 0) {
        //         let curSub = (curEntry[1] as PIC);
        //         if (curSub?.loadPageDOM) {
        //             curSub.clearEventListeners();
        //         }
        //     }
        // });
        // PICSubWin = [];
    }
    toggleMenu(iMenu) {
        this.menus.forEach(m => {
            if (m == iMenu) {
                m.isHidden = false;
                this.activePicker = m;
                m.parent.focus();
            }
            else if (!m.isHidden)
                m.isHidden = true;
        });
    }
    addMenu(iMenu) {
        if (iMenu)
            this.menus.push(iMenu);
    }
    removeMenu(iMenu) {
        this.menus = this.menus.filter(x => x != iMenu);
    }
    togglePicker(iPicker) {
        this.pickers.forEach(m => {
            m.toggle();
        });
    }
    addPicker(iPicker) {
        if (iPicker)
            this.pickers.push(iPicker);
    }
    removePicker(iPicker) {
        this.pickers = this.pickers.filter(x => x != iPicker);
    }
    dragTimer(iType, iUploadField, toggle) {
        this.dragTimeoutId ? clearTimeout(this.dragTimeoutId) : '';
        if (!toggle) {
            this.dragTimeoutId = setTimeout(() => {
                this.toggleUploadFields(iType, iUploadField, toggle);
                this.dragTimeoutId = undefined;
            }, 30);
        }
        else {
            this.toggleUploadFields(iType, iUploadField, toggle);
        }
    }
    toggleUploadFields(iType, iUploadField, toggle) {
        if (iType == 'Files') {
            this.uploadfields.forEach(f => f.isExtraVisible = toggle);
        }
    }
    addUploadField(iUploadField) {
        if (iUploadField)
            this.uploadfields.push(iUploadField);
    }
    removeUploadField(iUploadField) {
        this.uploadfields.forEach(f => f != iUploadField);
    }
    eventHandler(eventStr, inputEvent) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
        switch (eventStr) {
            case 'DOMContentLoaded':
                if (PIC.getInstance.subwin === "logon" && PIC.getInstance.user === "") {
                    console.log("Initializing State");
                    if ('documentMode' in document) {
                        window.history.pushState({}, "", location.pathname);
                    }
                    else
                        history.pushState({}, "", "");
                }
                if (!document.querySelector("pic-choicebox[choicebox-x]")) {
                    let cb = document.createElement("pic-choicebox");
                    cb.setAttribute("choicebox-x", "");
                    document.body.appendChild(cb);
                }
                if (!document.querySelector("pic-context[context-x]")) {
                    let cm = document.createElement("pic-context");
                    cm.setAttribute("context-x", "");
                    cm.setAttribute("mode", "table");
                    document.body.appendChild(cm);
                }
                window._log('GlobEvents, settings fetchformdata listeners');
                fetchFormData.setOnPopState();
                fetchFormData.setSubmitListener();
                this.clearActiveModalFocusElements();
                //TODO: make actions activate on load
                //PIC.getInstance.ActionList.forEach((action:PICAction) => action.triggerEvent(inputEvent));
                //PIC.getInstance.ActionList = [];
                break;
            case 'error':
                PIC.getInstance.error.addError(inputEvent);
                break;
            case 'click':
            case 'wheel':
            case 'scroll':
            case 'touchmove':
                if (this.activePicker) {
                    if (this.activePicker.pickerMode) {
                        if (this.activePicker.pickerMode == 'ignoreClick' && eventStr == 'click') {
                            // do nothing
                        }
                        else if (this.activePicker.pickerMode == 'ignoreScroll' && ['scroll', 'wheel', 'touchmove'].includes(eventStr)) {
                            // do nothing
                        }
                        else if (this.activePicker.pickerMode == 'ignoreLocalScroll' && ['scroll', 'wheel', 'touchmove'].includes(eventStr) && this.activePicker.picker) {
                            if (inputEvent.target instanceof PICLoadPage || inputEvent.target instanceof PICModal) {
                                if (inputEvent.composedPath().includes(this.activePicker.picker)) {
                                    //do nothing
                                }
                                else {
                                    (_a = this.activePicker.picker) === null || _a === void 0 ? void 0 : _a.hide();
                                }
                            }
                            else if ((inputEvent.target instanceof PICSelector || inputEvent.target instanceof PICSuggestion) && inputEvent.target.menu && inputEvent.target.menu == this.activePicker.picker) {
                                // do nothing 
                            }
                            else if ((inputEvent.target instanceof PICDate || inputEvent.target instanceof PICDualDate) && inputEvent.target.datePicker == this.activePicker.picker) {
                                // do nothing
                            }
                            else if (inputEvent.target instanceof PICTime && inputEvent.target.timePicker_ == this.activePicker.picker) {
                                // do nothing
                            }
                            else if (inputEvent.target instanceof PICHatchClerk) {
                                // do even more nothing
                            }
                            else if (inputEvent.target instanceof PICTab && inputEvent.composedPath().includes(this.activePicker.picker)) {
                                // do even more nothing
                            }
                            else {
                                (_b = this.activePicker.picker) === null || _b === void 0 ? void 0 : _b.hide();
                            }
                        }
                        else {
                            (_c = this.activePicker.picker) === null || _c === void 0 ? void 0 : _c.hide();
                        }
                    }
                    else {
                        (_d = this.activePicker.picker) === null || _d === void 0 ? void 0 : _d.hide();
                    }
                }
                break;
            case 'keydown':
                let kEvt = inputEvent;
                switch (kEvt.code) {
                    case 'F5':
                        if (PIC.sessionCode !== 'html.') {
                            inputEvent.preventDefault();
                            inputEvent.stopPropagation();
                            doSubmit('refresh');
                            return false;
                        }
                    case 'Tab':
                        // Modal is active, trap focus
                        if (this.activeModal) {
                            // Focus is on browser element, set to firstElm.
                            if (!document.activeElement) {
                                kEvt.preventDefault();
                                kEvt.stopPropagation();
                                (_e = this.activeModalFirstElm) === null || _e === void 0 ? void 0 : _e.focus();
                                if (this.activeModalFirstElm instanceof PICWebTable) {
                                    this.activeModalFirstElm.handleFocusOnTable(kEvt.shiftKey);
                                }
                                return;
                            }
                            //Tabbed outside of modal
                            if (document.activeElement !== this.activeModal && !this.activeModal.contains(document.activeElement)) {
                                kEvt.preventDefault();
                                kEvt.stopPropagation();
                                if (kEvt.shiftKey) { // shift + tab  
                                    (_f = this.activeModalLastElm) === null || _f === void 0 ? void 0 : _f.focus();
                                    if (this.activeModalLastElm instanceof PICWebTable) {
                                        this.activeModalLastElm.handleFocusOnTable(kEvt.shiftKey);
                                    }
                                    return;
                                }
                                else { // tab 
                                    (_g = this.activeModalFirstElm) === null || _g === void 0 ? void 0 : _g.focus();
                                    if (this.activeModalFirstElm instanceof PICWebTable) {
                                        this.activeModalFirstElm.handleFocusOnTable(kEvt.shiftKey);
                                    }
                                    return;
                                }
                            }
                            if ((this.activeModal === document.activeElement || this.activeModal.contains(document.activeElement)) && ((_h = this.activeModal.shadowRoot) === null || _h === void 0 ? void 0 : _h.contains(this.topModal))) {
                                //Tabbing backwards from firstElm
                                if ((document.activeElement === this.activeModalFirstElm || ((_j = this.activeModal.shadowRoot) === null || _j === void 0 ? void 0 : _j.activeElement) === this.activeModalFirstElm) && kEvt.shiftKey) {
                                    if (this.activeModalFirstElm instanceof PICWebTable) {
                                        if ((this.activeModalFirstElm.infoheader && ((_k = this.activeModalFirstElm.shadowRoot) === null || _k === void 0 ? void 0 : _k.activeElement) === this.activeModalFirstElm.gridTable) ||
                                            (((_l = this.activeModalFirstElm.tableBtns) === null || _l === void 0 ? void 0 : _l.length) && Array.from(this.activeModalFirstElm.tableBtns).includes((_m = this.activeModalFirstElm.shadowRoot) === null || _m === void 0 ? void 0 : _m.activeElement)) ||
                                            (((_o = this.activeModalFirstElm.filterRowInputs) === null || _o === void 0 ? void 0 : _o.length) && Array.from(this.activeModalFirstElm.filterRowInputs).includes((_p = this.activeModalFirstElm.shadowRoot) === null || _p === void 0 ? void 0 : _p.activeElement)))
                                            return;
                                    }
                                    kEvt.preventDefault();
                                    kEvt.stopPropagation();
                                    (_q = this.activeModalLastElm) === null || _q === void 0 ? void 0 : _q.focus();
                                    if (this.activeModalLastElm instanceof PICWebTable) {
                                        this.activeModalLastElm.handleFocusOnTable(kEvt.shiftKey);
                                    }
                                    return;
                                }
                                //Tabbing forwards from lastElm
                                else if ((document.activeElement === this.activeModalLastElm || ((_r = this.activeModal.shadowRoot) === null || _r === void 0 ? void 0 : _r.activeElement) === this.activeModalLastElm) && !kEvt.shiftKey) {
                                    if (this.activeModalLastElm instanceof PICWebTable) {
                                        if (((_s = this.activeModalLastElm.shadowRoot) === null || _s === void 0 ? void 0 : _s.activeElement) === this.activeModalLastElm.headerFilterMain ||
                                            (((_t = this.activeModalLastElm.tableBtns) === null || _t === void 0 ? void 0 : _t.length) && Array.from(this.activeModalLastElm.tableBtns).includes((_u = this.activeModalLastElm.shadowRoot) === null || _u === void 0 ? void 0 : _u.activeElement)) ||
                                            (((_v = this.activeModalLastElm.filterRowInputs) === null || _v === void 0 ? void 0 : _v.length) && Array.from(this.activeModalLastElm.filterRowInputs).includes((_w = this.activeModalLastElm.shadowRoot) === null || _w === void 0 ? void 0 : _w.activeElement)))
                                            return;
                                    }
                                    kEvt.preventDefault();
                                    kEvt.stopPropagation();
                                    (_x = this.activeModalFirstElm) === null || _x === void 0 ? void 0 : _x.focus();
                                    if (this.activeModalFirstElm instanceof PICWebTable) {
                                        this.activeModalFirstElm.handleFocusOnTable(kEvt.shiftKey);
                                    }
                                    return;
                                }
                                //Tabbing into a table
                                else if (this.topModal && this.topModal.isNew) {
                                    let activeElement = (_z = (_y = kEvt.target) === null || _y === void 0 ? void 0 : _y.shadowRoot) === null || _z === void 0 ? void 0 : _z.activeElement;
                                    if (activeElement instanceof PICWebTable)
                                        return;
                                    let modalChildren = Array.from((_0 = this.topModal.bdy[0]) === null || _0 === void 0 ? void 0 : _0.querySelectorAll(this.topModal.selstr));
                                    if (modalChildren.length > 1) {
                                        let activeElementIndex = modalChildren.indexOf(activeElement);
                                        if (activeElementIndex !== -1) {
                                            let next = null;
                                            if (kEvt.shiftKey) {
                                                if (activeElementIndex === 0)
                                                    next = modalChildren[modalChildren.length - 1];
                                                else
                                                    next = modalChildren[activeElementIndex - 1];
                                            }
                                            else {
                                                if (activeElementIndex === (modalChildren.length - 1))
                                                    next = modalChildren[0];
                                                else
                                                    next = modalChildren[activeElementIndex + 1];
                                            }
                                            if (next instanceof PICWebTable) {
                                                kEvt.preventDefault();
                                                kEvt.stopPropagation();
                                                next.handleFocusOnTable(kEvt.shiftKey);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        break;
                }
                if (kEvt.ctrlKey) {
                    PIC.getInstance.ctrlKeyIsDown = true;
                }
                break;
            case 'keyup':
                PIC.getInstance.ctrlKeyIsDown = false;
                break;
            case 'dragenter':
            case 'dragover':
                inputEvent.preventDefault();
                if ((_1 = inputEvent.dataTransfer) === null || _1 === void 0 ? void 0 : _1.types.includes('Files'))
                    this.dragTimer('Files', undefined, true);
                break;
            case 'dragleave':
            case 'dragend':
                inputEvent.preventDefault();
                if ((_2 = inputEvent.dataTransfer) === null || _2 === void 0 ? void 0 : _2.types.includes('Files'))
                    this.dragTimer('Files', undefined, false);
            case 'drop':
                let oldFileField = inputEvent.composedPath()[0];
                if (oldFileField && oldFileField.tagName == 'INPUT' && oldFileField.type == 'file') {
                    oldFileField.files = inputEvent.dataTransfer.files;
                    inputEvent.preventDefault();
                }
                else {
                    inputEvent.preventDefault();
                    if ((_3 = inputEvent.dataTransfer) === null || _3 === void 0 ? void 0 : _3.types.includes('Files'))
                        this.dragTimer('Files', undefined, false);
                }
                break;
            case 'dragstart':
            case 'drag':
                //commented out so drag works in websearch table
                //inputEvent.preventDefault();
                break;
            case 'PICSubmit':
            case 'ModalClosed':
                this.clearActiveModalFocusElements();
                break;
            case 'ModalOpened':
                if (this.openModals.length > 0) {
                    this.openModals.forEach(modal => modal.hideOverlay());
                }
                break;
            case 'resize':
                let modaltables = [];
                if (this.openModals.length > 0) {
                    this.openModals.forEach(modal => {
                        modal.handleWindowResize();
                        modal.querySelectorAll('pic-webtable').forEach(table => {
                            if (table.autoFitTable)
                                modaltables.push(table);
                        });
                    });
                }
                if (PIC.getInstance.picInputs.size > 0) {
                    for (const [key, value] of PIC.getInstance.picInputs.entries()) {
                        if (value instanceof PICWebTable && !modaltables.find(mtable => mtable.id === value.id)) {
                            if (value.autoFitTable) {
                                value.resetAutoFitHeight();
                                value.handleAutoFit(true);
                            }
                            else {
                                value.handleAutoFit();
                            }
                        }
                    }
                }
                break;
            default:
                break;
        }
    }
    scrollHandler(e) {
        if (PIC.getInstance.picInputs.size > 0) {
            for (const [key, value] of PIC.getInstance.picInputs.entries()) {
                if (value instanceof PICWebTable) {
                    value.handleExternalScroll();
                }
            }
        }
    }
    setGlobalListeners() {
        ['DOMContentLoaded', 'error', 'drop',
            'click', 'wheel', 'scroll', 'touchmove', 'dragend',
            'dragenter', 'dragleave', 'dragover', 'dragstart',
            'keydown', 'keyup', 'PICSubmit', 'resize', 'ModalClosed', 'ModalOpened'].forEach(eventStr => {
            this.addEventListener(eventStr, (event) => this.eventHandler(eventStr, event) /*, (eventStr == 'error'?{capture: true}:undefined)*/);
        });
        this.addEventListener('scroll', Util._throttle(this, this.scrollHandler, 20), true);
        window.addEventListener('blur', (e) => {
            PIC.getInstance.ctrlKeyIsDown = false;
        });
    }
}
//# sourceMappingURL=GlobEvents.js.map